import React from "react"
import { StaticQuery, graphql } from "gatsby"
import SocialMedia from "../components/socialMedia"

export default () => (
	<StaticQuery
		query = {graphql`
			query headingQuery {
				site {
					siteMetadata {
						home {
							title
							description
						}
					}
				}
			}
		`}

		render={data => (
			<div className="hero-header">
				<div className="headline">{data.site.siteMetadata.home.title}</div>

				<div
					className="primary-content"
					dangerouslySetInnerHTML={{ __html: data.site.siteMetadata.home.description }}
				/>

				<div className="tools-content">
					<a href="https://alvinau0427.github.io/" className="button -primary">Personal Portfolio</a>
					<SocialMedia />
				</div>
			</div>
		)}
	/>
)
